import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  width: '140px',
  height: '160px',
  loadingGap: '20px',
  arrowGap: '8px',
  get selectedColor() {
    return theme.color.primary;
  },
  get activeBgColor() {
    return theme.color.bg;
  },
  // empty
  empty: {
    padding: "16px",
    get color() {
      return theme.color.placeholder;
    }
  },
  // filter
  filter: {
    get highlightColor() {
      return theme.color.danger;
    },
    minWidth: '300px',
    maxHeight: '200px'
  }
};
var cascader;
setDefault(function () {
  cascader = deepDefaults(theme, {
    cascader: defaults
  }).cascader;
  makeMenuStyles == null || makeMenuStyles.clearCache();
  makeFilterMenuStyles == null || makeFilterMenuStyles.clearCache();
});
export var makeMenuStyles = cache(function makeMenuStyles(k) {
  return /*#__PURE__*/css("min-width:", cascader.width, "!important;height:", cascader.height, ";overflow:auto;.", k, "-cascader-arrow{float:right;height:100%;margin-left:", cascader.arrowGap, ";line-height:inherit;}.", k, "-cascader-loading{display:block;text-align:center;margin-top:", cascader.loadingGap, ";}.", k, "-cascader-empty{padding:", cascader.empty.padding, ";color:", cascader.empty.color, ";text-align:center;}.", k, "-cascader-option{&.", k, "-selected{color:", cascader.selectedColor, ";}&.", k, "-active{background:", cascader.activeBgColor, ";}}");
});
export var makeFilterMenuStyles = cache(function makeFilterMenuStyles(k) {
  return /*#__PURE__*/css("min-width:", _filterInstanceProperty(cascader).minWidth, "!important;height:auto;max-height:", _filterInstanceProperty(cascader).maxHeight, ";em{font-style:normal;color:", _filterInstanceProperty(cascader).highlightColor, ";}.", k, "-dropdown-item.", k, "-selected{color:", cascader.selectedColor, ";}");
});